import React, { useEffect, useState } from 'react';
import axios from 'axios';
// import logo from "../images/download.png"
import baseUrl from '../../../utils/config';
import Cookies from "js-cookie";
import { Link } from '@mui/material';
import ViewportMeta from '../../../utils/ViewportMeta';
import saudiExim from "../../../images/NEW FATS LOGO.png"
import { useNavigate } from 'react-router-dom';
import { DotLoader } from 'react-spinners'

//Secure Changes add in UserLoginPage Image added
function LoginForm() {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [isLoading, setIsLoading] = useState(false)
  const [error, setError] = useState(null);
  const Navigate = useNavigate()

  const handleFormSubmit = async (e) => {
    e.preventDefault();
    setIsLoading(true);
    try {
      // don't use newRequest here because it will set token in header and we don't want that here because we are using cookie
      // instead use axios here and set token in cookie using js-cookie library
      const response = await axios.post(baseUrl + "/login",
        {
          loginname: email,
          loginpass: password
        }
      );
      setIsLoading(false);
      // localStorage.setItem("currentUser", JSON.stringify(response?.data?.user));
      // set token in cookie
      Cookies.set("userToken", response?.data?.token);
      sessionStorage.setItem('userToken', response?.data?.token)
      
      // Cookies.set("userToken", response?.data?.token);
      localStorage.setItem("userId", email);
      // window.location.href = "/assets";
      Navigate('/member/assets')
    }
    catch (error) {
      setIsLoading(false)
      setError(error?.response?.data?.message || error?.message || "Something went wrong!");

    }
  }
  useEffect(() => {
    setError(null);
  }, [email, password]);

  return (
    <>

      {isLoading && <div className='loading-spinner-background'
        style={{
          zIndex: 9999, position: 'absolute', top: 0, left: 0, width: '100%', height: '100%', backgroundColor: 'rgba(255, 255, 255, 0.5)',
          display: 'flex', justifyContent: 'center', alignItems: 'center', position: 'fixed'


        }}
      >
        <DotLoader
          size={45}
          color={"#FF693A"}
          // height={4}
          loading={isLoading}
        />
      </div>
      }
      <ViewportMeta />

      <form onSubmit={handleFormSubmit}>
        <div className="bg-black before:animate-pulse before:bg-gradient-to-b before:from-gray-900 overflow-hidden before:via-[#00FF00] before:to-gray-900 before:absolute">
          <div id="myDIV">
            <div className="w-full lg:w-[100vw] sm:w-full h-full lg:h-[100vh] sm:h-full px-3 sm:px-5 flex items-center justify-center absolute bg-gray-100">
              <div className="w-full sm:w-1/2 lg:2/3 px-6 bg-gradient-to-r from-[#b6bdf3] bg-opacity-20 bg-clip-padding backdrop-filter backdrop-blur-sm text-white z-50 py-4 rounded-lg">
                <div className='flex justify-center'>
                  {/* Nartec Image */}
                  <img src={saudiExim} className='h-60 w-full object-contain' alt='' />
                </div>
                <div className="w-full flex justify-center text-[#00006B] text-xl mb:2 md:mb-5">
                  Login-in Information
                </div>
                {/* Username */}
                <div className="mb-6">
                  <label htmlFor="username" className="block mb-2 text-xs font-medium text-[#00006B]">Username</label>
                  <input
                    required
                    value={email}
                    onChange={(e) => setEmail(e.target.value)}
                    type="username" id="username" className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-[#00006B] dark:focus:ring-blue-500 dark:focus:border-blue-500" placeholder="Username" />
                </div>

                {/* Password  */}
                <div className="mb-6">
                  <label htmlFor="password" className="block mb-2 text-xs font-medium text-[#00006B]">Your password</label>
                  <input
                    required
                    value={password}
                    onChange={(e) => setPassword(e.target.value)}
                    type="password" id="password" placeholder='Password' className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" />
                </div>

                {/* Drop Down */}
                <div className="mb-6">
                  {/* <label htmlFor="password" className="block mb-2 text-xs font-medium text-white">Your password</label> */}
                  <select id="select" className="bg-gray-50 border border-gray-300 text-gray-900 text-xs rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-1.5 md:p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500" required>
                    <option value="select1">English</option>
                    <option value="select2">Arabic</option>
                  </select>
                </div>

                <div className="mb-6">
                  {error && (
                    <div
                      className="mt-4 text-sm text-center text-red-500"
                    >
                      <div
                        className="bg-red-100 border border-red-400 text-red-700 px-4 py-3 rounded relative"
                      >
                        {error}
                      </div>
                    </div>
                  )}
                </div>
                {/* Login Button */}
                <div className="mt-4 md:mt-10 w-full flex justify-center text-sm md:text-xl py-2 rounded-md">
                  <button type='submit' className="bg-[#00006B] text-white font-bold py-3 px-20 rounded-l">
                    Login
                  </button>
                </div>

              </div>
            </div>
          </div>
          {/* <div id="myDIV" className="flex flex-wrap gap-0.5 h-screen items-center justify-center relative" dangerouslySetInnerHTML={{__html: el}}></div> */}
        </div>
      </form>
      
    </>
  );
}

export default LoginForm;
